import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
/**
 * List of all shorthand props that we need to convert to css
 */ var layoutProps = {
    $p: "padding",
    $m: "margin",
    $px: [
        "paddingLeft",
        "paddingRight"
    ],
    $mx: [
        "marginLeft",
        "marginRight"
    ],
    $py: [
        "paddingTop",
        "paddingBottom"
    ],
    $my: [
        "marginTop",
        "marginBottom"
    ],
    $pt: "paddingTop",
    $mt: "marginTop",
    $pr: "paddingRight",
    $mr: "marginRight",
    $pb: "paddingBottom",
    $mb: "marginBottom",
    $pl: "paddingLeft",
    $ml: "marginLeft"
};
var convertLayoutProps = function(values) {
    return Object.entries(layoutProps).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], cssProps = _param[1];
        var value = values[key];
        if (value === null || value === undefined) {
            return acc;
        }
        if (Array.isArray(cssProps)) {
            cssProps.forEach(function(p) {
                acc[p] = value;
            });
        } else {
            acc[cssProps] = value;
        }
        return acc;
    }, {});
};
export default convertLayoutProps;
